<template>
  <mdb-col sm="12" md="4">
    <div class="image-container">
      <img :src="serviceImage" class="circle-image" :alt="serviceImageAlt" />
    </div>
    <h2 class="title-text">{{ serviceTitle }}</h2>
    <div class="body-text" v-html="serviceBody"></div>
  </mdb-col>
</template>

<script>
import {
  mdbCol
} from 'mdbvue'

export default {
  name: 'ServicesShowcaseItem',
  props: {
    serviceImage: String,
    serviceImageAlt: String,
    serviceTitle: String,
    serviceBody: String
  },
  components: {
    mdbCol
  }
}
</script>

<style scoped>
.image-container {
/*   border: 3px solid #949494; */
/*   background-color: #080808; */
  padding-bottom: 15px;
}

.circle-image {

}

.title-text {
  font-family: arial, 'sans-serif';
  font-size: 22px;
  color: #DEDEDE;
}

.body-text {
  font-family: 'Roboto', arial, 'sans-serif';
  font-family: 12px;
  color: #DEDEDE;
  padding-bottom: 25px;
}
</style>